export const apiLoginGG = `api/identity/google-login`
